import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HopperRestaurantNumberPage = ({ components }) => {
    const getDataIetm = (component) => {
        return (
            component?.Data?.map((val, key) => {
                return (
                    <div className="HopperRestaurantNumberPage-card" key={key}>
                        <div className="HopperRestaurantNumberPage-card-count">{val?.count}
                        </div>
                        <div className="HopperRestaurantNumberPage-card-cont">
                            <div className="HopperRestaurantNumberPage-card-cont-header">{val?.header}</div>
                            <div className="HopperRestaurantNumberPage-card-cont-subheader">{val?.subheader}</div>
                        </div>
                    </div>
                )
            })
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperRestaurantNumberPage-card":
                return getDataIetm(component)

            default:
                return <div />
        }

    }
    return (
        <div className="HopperRestaurantNumberPage">

            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HopperRestaurantNumberPage